<template>
  <div>
    <div style="height: 100%; overflow-y: auto;">
      <a 
        v-if="step>0"
        href="https://wa.me/34622859056"
        target="_blank"
        class="position-fixed bg-white py-2 px-3"
        style="z-index: 1000 !important;border-radius: 1000px; bottom: 4rem; right: 2rem;">
        <i class="fs-2 fa-brands fa-whatsapp text-success"></i>
      </a>
      <div 
        v-if="step==0"
        class="h-100 w-100 align-items-center d-flex"
        style="background-color: #f5f5f5; position: fixed; z-index: 10000 !important; overflow-y: scroll;">
        <div style="max-height: 100%; ">
          <div class="w-100 h-100 top-0">
            <div 
              style="color:rgb(1, 22, 56);"
              class="px-5 text-center fw-semibold">
              <h2>👋</h2>
              <h2 
                class="mb-4 fw-bold" 
                style="font-size:2.5rem">¡Hola, Parker!</h2>
              <p 
                style="font-size:1.2rem"
                class="mb-4 fw-light">Completa el formulario con los datos de tu garaje.</p>
              <!--<h4 class="mb-4 fw-bold">¡Estás en el sitio correcto!</h4>-->
              <div class="fw-light mb-3">
                <p
                  class="fw-bold"
                  style="font-size:1.1rem">
                  ⚠️ ️Recibirás por Whatsapp las solicitudes de los interesados. Tú eliges con quién contactar.
                </p>
                <a 
                  href="https://wa.me/34622859056"
                  target="_blank"
                  class="text-decoration-none fw-light"
                  style="font-size:1.1rem; color: rgb(1, 22, 56)">
                  Si tienes dudas durante el proceso, estamos aquí para ayudarte 
                  <i class="ms-2 fs-3 fa-brands fa-whatsapp text-success"></i>
                </a>
                <p
                  class="fw-semibold mt-3"
                  style="font-size:1.1rem">
                  Empieza hoy a rentabilizar tu garaje con Parkiduo.
                </p>
              </div>
              <button
                class="btn py-2 w-100 rounded-3 mt-4"
                style="background-color: #011638; font-size: 1.1rem;font-weight: 700; color: white"
                @click="this.step++; trackMixPanel('apphomeparker_click_empezar')"
              >
                <span>EMPEZAR</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="step<7"
        id="folding_tab"
        class="px-4"
        :class="{ collapsed: isCollapsed }"
      >
        <div 
          class="pt-2"
          style="height: 45px;">
          <div class="stepper-wrapper">
            <div class="stepper">
              <div 
                :class="step>1 ? '' : 'opacity-0'" 
                class="step-container">
                <div class="step completed"></div>
                <div class="step-label">{{ steps_names[step-1] }}</div>
              </div>
              <div class="step-container">
                <div class="step active"></div>
                <div class="step-label">{{ steps_names[step] }}<br><span class="fw-bold">{{ step }}/6</span></div>
              </div>
              <div 
                :class="step<6 ? '' : 'opacity-0'"
                class="step-container">
                <div class="step"></div>
                <div class="step-label">{{ steps_names[step+1] }}</div>
              </div>
            </div>
            <!-- Líneas entre pasos -->
            <div
              :class="step>1 ? '' : 'opacity-0'" 
              class="line line-1"></div>
            <div 
              :class="step<6 ? '' : 'opacity-0'"
              class="line line-2"></div>
          </div>
        </div>
        <div>
          <div v-if="step==1">
            <div class="mb-0 mt-4 ">
              <i
                class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                style="color:#011638; border-radius: 1000px; "
                @click="step--"
              />
              <span
                style="color:#011638; font-size: 0.8rem;"
                class="ms-3 mb-1 fw-semibold ms-2"
              >UBICACIÓN DE TU GARAJE</span>
            </div>
            <div
              style="height: calc(100vh - 155px);">
              <address-browser-component
                text="Indica la dirección de tu garaje"
                title=" "
                :is_parker="true"
                @get-data-address="handleGetAddress"
                @address-selected="trackMixPanel('applocationparker_click_searchresults')"
                @clicked-icon="trackMixPanel('applocationparker_click_icon')"
                :address="this.input.address"
              />
            </div>
          </div>
          <div
            v-else-if="step==2"
            class=""
            style="display: flex; flex-direction: column; height: 100%;"
          >
            <div style="flex-grow: 1; overflow: auto;">
              <div class="m-0 mt-4 ">
                <i
                  class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                  style="color:#011638; border-radius: 1000px; "
                  @click="step--"
                />
                <span
                  style="color:#011638; font-size: 0.8rem;"
                  class="ms-3 mb-1 fw-semibold ms-2"
                >HORARIO DE ALQUILER DE TU GARAJE</span>
              </div>
              <!--<div class="row m-0 mt-3">
                <div class="col">
                  <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                    <i
                      class="fa-solid fa-location-dot me-2"
                      style="font-size: 1.2rem;"
                    />
                    UBICACIÓN
                  </span>
                  <p
                    class="mb-0"
                    style="color:#011638"
                  >
                    {{ input.address.street }}
                  </p>
                  <p
                    class="mb-0"
                    style="color:#011638"
                  >
                    {{ input.address.city }}
                  </p>
                </div>
              </div>-->
              <div
                class="row m-0 mt-2"
                style="color:#011638"
              >
                <div class="row m-0 bg-white rounded-top-4 py-3">
                  <span class="col">Lunes a viernes </span>
                  <div class="form-check form-switch col-2 d-flex justify-content-end">
                    <input
                      id="flexSwitchCheckDefault"
                      v-model="weekdays"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                    >
                  </div>
                </div>
                <div
                  v-if="!full_day && weekdays"
                  class="row m-0 bg-white py-3 ps-4"
                >
                  <span class="col">Franja horaria</span>
                  <time-component
                    ref="time_component"
                    class="col"
                    :es-deshabilitado="full_day"
                    @get-data-horas="handleGetDataHoras"
                  />
                </div>
              </div>
              <div
                v-if="weekdays"
                class="row m-0 bg-white rounded-bottom-4 py-3 ps-4 pe-2 "
              >
                <span class="col">Día entero (24h)</span>
                <div class="form-check form-switch col-2 d-flex justify-content-end me-1">
                  <input
                    id="flexSwitchCheckDefault"
                    v-model="full_day"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                  >
                </div>
              </div>
              <div
                class="row m-0 mt-2"
                style="color:#011638"
              >
                <p
                  style="color:#56647A"
                  class="mb-1"
                />
                <div class="row m-0 bg-white rounded-3 py-3">
                  <span class="col">Sábado y domingo (24h)</span>
                  <div class="form-check form-switch col-2 d-flex justify-content-end">
                    <input
                      id="flexSwitchCheckDefault"
                      v-model="input.weekend_full_day"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                    >
                  </div>
                </div>
              </div>
              <p
                v-if="hour_error"
                class="text-danger text-center mt-3"
              >
                Introduce un horario correcto
              </p>
            </div>
            <div
              style="height: 50px;"
              class="mt-3"
            >
              <button
                class="btn py-2 w-100 rounded-3"
                style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
                @click="(weekdays || input.weekend_full_day) ? (step++, hour_error = false, trackMixPanel('apptimeparker_click_siguiente')) : (hour_error = true)"
              >
                <span>Siguiente <i
                  class="fa-solid fa-angle-right ms-1"
                  style="font-size: 1rem;"
                /></span>
              </button>
            </div>
          </div>
          <div
            v-else-if="step==3"
            class=""
            style="display: flex; flex-direction: column; height: 100%;"
          >
            <div
              style="flex-grow: 1; overflow-y: auto; overflow-x: hidden;"
            >
              <div class="m-0 mt-4 ">
                <i
                  class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                  style="color:#011638; border-radius: 1000px; "
                  @click="step--; $nextTick(() => { if ($refs.time_component) { $refs.time_component.CambiarHoras(input.time); } })"
                />
                <span
                  style="color:#011638; font-size: 0.8rem;"
                  class="ms-3 mb-1 fw-semibold ms-2"
                >TAMAÑO DE TU PLAZA</span>
              </div>
              <!--<div class="row m-0 mt-3">
                <div class="col">
                  <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                    <i
                      class="fa-solid fa-location-dot me-2"
                      style="font-size: 1.2rem;"
                    />
                    UBICACIÓN
                  </span>
                  <p
                    class="mb-0"
                    style="color:#011638"
                  >
                    {{ formattedStreet }}
                  </p>
                  <p
                    class="mb-0"
                    style="color:#011638"
                  >
                    {{ input.address.city }}
                  </p>
                </div>
                <div class="col">
                  <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                    <i
                      class="fa-regular fa-clock me-2"
                      style="font-size: 1.2rem;"
                    />
                    HORARIO
                  </span>
                  <p
                    v-if="input.time.startTime"
                    class="mb-0"
                    style="color:#011638"
                  >
                    L-V
                    <span v-if="input.time.startTime == '00:00' && input.time.endTime == '00:00'">
                      24h
                      <i
                        v-if="input.weekend_full_day"
                        class="fa-solid fa-check ms-2 text-success"
                      />
                    </span>
                    <span v-else>{{ input.time.startTime }}h - {{ input.time.endTime }}h</span>
                  </p>
                  <p
                    v-if="input.weekend_full_day"
                    class="mb-0"
                    style="color:#011638"
                  >
                    S-D 24h
                  </p>
                </div>
              </div>-->
              <div class="mt-3 bg-white ps-3 rounded-4 py-3">
                <div
                  class="d-flex mx-3 me-4 mt-2"
                >
                  <span class="pe-2">Tamaño</span>
                  <div 
                    class="flex-grow-1"
                    style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                    <p 
                      v-if="formattedSize?.length>0"
                      class="text-black text-end mb-0">Coche {{ formattedSize }}</p>
                  </div>
                  <div
                    style="color:#15E0DD" 
                    class="nav-item dropdown-toggle">
                    <a
                      style="color:#15E0DD"
                      data-bs-toggle="dropdown"
                      href="#"
                      role="button"
                      aria-expanded="false"
                    >
                      <i class="fa-solid fa-car ms-2" />
                    </a>
                    <ul class="dropdown-menu">
                      <li @click="input.vehicle_size='small'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Pequeño (3,6 x 1,6m)</a>
                      </li>
                      <li @click="input.vehicle_size='medium'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Mediano (4,5 x 1,8m)</a>
                      </li>
                      <li @click="input.vehicle_size='large'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Grande (5,0 x 1,9m)</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <hr>
                <div class="d-flex justify-content-between align-items-center mx-3">
                  <span class="pe-2">Vehículo eléctrico</span>
                  <div class="form-check form-switch d-flex justify-content-end">
                    <input
                      id="flexSwitchCheckDefault"
                      v-model="input.electric_car"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                    >
                  </div>
                </div>
              </div>
              <!--<div class="mt-3 bg-white ps-3 rounded-4">
                <div
                  class="row m-0"
                  @click="input.vehicle_size='small'"
                >
                  <p
                    class="py-3 mb-0 col-10"
                    style="color:#8E97A7"
                  >
                    Coche pequeño (3,6 x 1,6m)
                  </p>
                  <i
                    v-if="input.vehicle_size=='small'"
                    class="fa-solid fa-check col-2 d-flex align-items-center"
                    style="color:#011638"
                  />
                </div>
                <hr class="my-0">
                <div
                  class="row m-0"
                  @click="input.vehicle_size='medium'"
                >
                  <p
                    class="py-3 mb-0 col-10"
                    style="color:#8E97A7"
                  >
                    Coche mediano (4,5 x 1,8m)
                  </p>
                  <i
                    v-if="input.vehicle_size=='medium'"
                    class="fa-solid fa-check col-2 d-flex align-items-center"
                    style="color:#011638"
                  />
                </div>
                <hr class="my-0">
                <div
                  class="row m-0"
                  @click="input.vehicle_size='large'"
                >
                  <p
                    class="py-3 mb-0 col-10"
                    style="color:#8E97A7"
                  >
                    Coche grande (5,0 x 1,9m)
                  </p>
                  <i
                    v-if="input.vehicle_size=='large'"
                    class="fa-solid fa-check col-2 d-flex align-items-center"
                    style="color:#011638"
                  />
                </div>
              </div>-->
              <p
                v-if="error"
                class="text-danger text-center mt-3"
              >
                Debe seleccionar un tamaño
              </p>
            </div>
            <div
              style="height: 50px;"
              class="mt-3"
            >
              <button
                class="btn py-2 w-100 rounded-3"
                style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
                @click="input.vehicle_size != null ? (step++, trackMixPanel('appsizeparker_click_siguiente')) : error=true"
              >
                <span>Siguiente <i
                  class="fa-solid fa-angle-right ms-1"
                  style="font-size: 1rem;"
                /></span>
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="step==4"
          style="background-color: #F5F6F8;width: 100%;"
          class="position-relative"
        >
          <div class="m-0 mt-4 ">
            <i
              class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
              style="color:#011638; border-radius: 1000px; "
              @click="step--"
            />
            <span
              style="color:#011638; font-size: 0.8rem;"
              class="ms-3 mb-1 fw-semibold ms-2"
            >PRECIO MENSUAL Y PERIODO</span>
          </div>
          <div>
            <div >
              <div
                class="bg-white rounded-4 p-3 my-3"
                style="color:#011638"
              >
                <div
                  class="d-flex justify-content-start align-items-center"
                  @click="$refs.input_price.focus()"
                >
                  <input
                    ref="input_price"
                    v-model="input.monthly_price"
                    type="number"
                    class="border-0 mx-0 p-0 input-no-border"
                    :style="input.monthly_price !== null ? { width: input.monthly_price.toString().length + 1 + 'ch' } : {}"
                    placeholder="Precio mensual en € (*)"
                    @input="handleInputPrice"
                  >
                  <span v-if="input.monthly_price !== null">€/mes</span>
                </div>
                <hr>
                <div
                  class="d-flex justify-content-between align-items-center "
                >
                  <p class="mb-0 pe-2">
                    Periodo de alquiler
                  </p>
                  <div class="">
                    <div class="nav-item dropdown w-100">
                      <a
                        class="nav-link dropdown-toggle w-100 text-end"
                        style="color:#15E0DD"
                        data-bs-toggle="dropdown"
                        href="#"
                        role="button"
                        aria-expanded="false"
                      >
                        {{ formattedPeriod }}
                        <i class="fa-regular fa-calendar ms-2" />
                      </a>
                      <ul class="dropdown-menu">
                        <li @click="input.duration='1-6months'">
                          <a
                            class="dropdown-item"
                            href="#"
                          >1-6 meses</a>
                        </li>
                        <li @click="input.duration='6-12months'">
                          <a
                            class="dropdown-item"
                            href="#"
                          >6-12 meses</a>
                        </li>
                        <li @click="input.duration='indefinite'">
                          <a
                            class="dropdown-item"
                            href="#"
                          >Indefinido</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!--
              <p
                class="mb-0 fw-semibold ms-2"
                style="color:#56647A; font-size: 0.7rem;"
              >
                ¿ES TU PLAZA O LA TIENES ALQUILADA? (*)
              </p>
              <div
                class="bg-white rounded-4 p-3 my-3"
                style="color:#011638"
              >
                <div
                  class="row m-0"
                  @click="input.type='owned'"
                >
                  <p
                    class="py-0 mb-0 col-10"
                    style="color:#011638"
                  >
                    En propiedad
                  </p>
                  <div class="col-2 d-flex align-items-center p-0">
                    <input
                      v-model="input.type"
                      class="form-check-input"
                      style="height: 15px !important;"
                      type="radio"
                      value="owned"
                    >
                  </div>
                </div>
                <hr>
                <div
                  class="row m-0"
                  @click="input.type='rented'"
                >
                  <p
                    class="py-0 mb-0 col-10"
                    style="color:#011638"
                  >
                    Alquilada
                  </p>
                  <div class="col-2 d-flex align-items-center p-0">
                    <input
                      v-model="input.type"
                      class="form-check-input"
                      style="height: 15px !important;"
                      type="radio"
                      value="rented"
                    >
                  </div>
                </div>
              </div>
              -->
              <span
                v-if="form_error"
                class="text-danger px-3"
              >
                Rellena los campos obligatorios (*)
              </span>
              <div
                style="height: 50px;"
                class="mt-3"
              >
                <button
                  class="btn py-2 w-100 rounded-3"
                  style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
                  @click="(input.monthly_price != null) ? (step++, trackMixPanel('appcompleteinfoparker_click_siguiente'), form_error=false) : form_error=true"
                >
                  <span>Siguiente <i
                    class="fa-solid fa-angle-right ms-1"
                    style="font-size: 1rem;"
                  /></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="step==5"
          style="background-color: #F5F6F8;width: 100%;"
          class="position-relative"
        >
          <div class="m-0 mt-4 ">
            <i
              class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
              style="color:#011638; border-radius: 1000px; "
              @click="step--"
            />
            <span
              style="color:#011638; font-size: 0.8rem;"
              class="ms-3 mb-1 fw-semibold ms-2"
            >INFORMACIÓN ADICIONAL</span>
          </div>
          <div class="mt-3">
            <div
              class="bg-white rounded-4 p-3 mb-3"
              style="color:#011638"
            >
              <div
                class="d-flex justify-content-between align-items-center "
              >
                <p 
                  class="mb-0 pe-2" 
                  style="color:#011638">
                  Planta de tu garaje
                </p>
                <div class="">
                  <div class="nav-item dropdown w-100">
                    <a
                      class="nav-link dropdown-toggle w-100 text-end"
                      style="color:#15E0DD"
                      data-bs-toggle="dropdown"
                      href="#"
                      role="button"
                      aria-expanded="false"
                    >
                      {{ formattedFloor }}
                      <i class="fa-solid fa-elevator ms-2" />
                    </a>
                    <ul class="dropdown-menu">
                      <li @click="input.floor='-5'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Sótano -5</a>
                      </li>
                      <li @click="input.floor='-4'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Sótano -4</a>
                      </li>
                      <li @click="input.floor='-3'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Sótano -3</a>
                      </li>
                      <li @click="input.floor='-2'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Sótano -2</a>
                      </li>
                      <li @click="input.floor='-1'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Sótano -1</a>
                      </li>
                      <li @click="input.floor='0'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta Baja</a>
                      </li>
                      <li @click="input.floor='1'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 1</a>
                      </li>
                      <li @click="input.floor='2'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 2</a>
                      </li>
                      <li @click="input.floor='3'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 3</a>
                      </li>
                      <li @click="input.floor='4'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 4</a>
                      </li>
                      <li @click="input.floor='5'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 5</a>
                      </li>
                      <li @click="input.floor='6'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 6</a>
                      </li>
                      <li @click="input.floor='7'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 7</a>
                      </li>
                      <li @click="input.floor='8'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 8</a>
                      </li>
                      <li @click="input.floor='9'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 9</a>
                      </li>
                      <li @click="input.floor='10'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Planta 10</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <hr>
              <p
                class="mb-1" 
                style="color:#011638">Descripción de tu plaza</p>
              <textarea
                v-model="input.comments"
                class="form-control border mx-0 col mb-3"
                placeholder="Ej: Plaza amplia, fácil acceso y cerca del ascensor."
                style="min-height: 30px;border-color: #011638 !important;"
              />
              <hr>
              <div>
                <p
                  class="mb-1" 
                  style="color:#011638">Características</p>
                <div class="d-flex flex-wrap">
                  <span
                    v-for="(tag, index) in default_tags"
                    :key="index"
                    class="etiqueta"
                    :class="input.tags.includes(tag) ? 'selected_tag' : ''"
                    @click="toggleTag(tag)"
                  >
                    {{ formatTag(tag) }}
                  </span>
                  <!--
                  <span
                    class="etiqueta"
                    :class="input.electric_car ? 'selected_tag' : ''"
                    @click="input.electric_car ? input.electric_car = false : input.electric_car = true"
                  >
                    Cargador eléctrico
                  </span>-->
                </div>
              </div>
            </div>
            <span
              v-if="form_error"
              class="text-danger px-3"
            >
              Rellena los campos obligatorios (*)
            </span>
            <div
              style="height: 50px;"
              class="mt-1"
            >
              <button
                class="btn py-2 w-100 rounded-3"
                style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
                @click="step++, trackMixPanel('appcompleteinfoparker_click_siguiente'), form_error=false"
              >
                <span>Siguiente <i
                  class="fa-solid fa-angle-right ms-1"
                  style="font-size: 1rem;"
                /></span>
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="step==6"
          style="background-color: #F5F6F8;width: 100%;min-height: 100%;"
          class="position-relative"
        >
          <div class="m-0 mt-4 ">
            <i
              class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
              style="color:#011638; border-radius: 1000px; "
              @click="step--"
            />
            <span
              style="color:#011638; font-size: 0.8rem;"
              class="ms-3 mb-1 fw-semibold ms-2"
            >IMÁGENES DE TU GARAJE</span>
          </div>
          <div class="mt-3">
            <div 
              class="rounded border border-3 d-flex align-items-center mt-2"
              style="height: 25vh; object-fit: cover; width: 100%;">
              <div>
                <div class="w-100 d-flex  justify-content-center">
                  <img
                    :src="noPhoto"
                    style="width: 20%;">
                </div>
                <p class="text-center">Selecciona las imágenes que quieres subir</p>
                <div
                  class="d-flex justify-content-center px-3"
                >
                  <div
                    class="btn btn-light border py-2 flex-grow-1 rounded-4"
                    style="color: #56647A; font-weight: 600;"
                    @click="triggerCamera"
                  >
                    <i
                      class="fa-solid fa-camera me-1"
                      style="font-size: 0.7rem;"
                    />
                    Hacer una foto
                  </div>
                  <input
                    ref="cameraInput"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style="display: none"
                    multiple
                    @change="handleFileChange"
                  >
                  <div
                    class="btn btn-light py-2 border flex-grow-1 rounded-4 ms-2"
                    style="color: #56647A; font-weight: 600;"
                    @click="triggerFileInput"
                  >
                    <i
                      class="fa-regular fa-images me-1"
                      style="font-size: 0.7rem;"
                    />
                    Importar
                  </div>
                  <input
                    ref="fileInput"
                    type="file"
                    accept="image/*"
                    style="display: none"
                    multiple
                    @change="handleFileChange"
                  >
                </div>
              </div>
            </div>
            <p
              class="mb-1 fw-semibold mt-3 mb-2"
              style="color:#56647A; font-size: 0.8rem;"
              v-if="input.imgs.length > 0"
            >
              Imágenes subidas de tu plaza:
            </p>
            <div class="contenedor-imagenes px-4">
              <div
                v-for="(img, index) in input.imgs"
                :id="'img'+index"
                :key="index"
                class="imagen-wrapper position-relative"
                :class="index === 0 ? 'active' : ''"
              >
                <img
                  :src="img"
                  style="object-fit: cover;"
                  class="imagen"
                  alt="..."
                >
                <i
                  class="fa-solid fa-trash position-absolute"
                  style="bottom: 20px; left: 20px;color:#15E0DD; z-index:1000"
                  @click="deleteImage(index)"
                />
              </div>
            </div>
            <button
              class="btn py-2 w-100 rounded-3 my-4"
              style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
              @click="save_parker"
            >
              <span>Registrar plaza de garaje</span>
            </button>
          </div>
        </div>
      </div>
      
      <div
        v-if="completed"
        style="height: calc(100% - 80px);"
        class="d-flex align-items-center"
      >
        <div class="w-100">
          <div class="w-100 d-flex mb-5 justify-content-center">
            <img
              src="@/assets/checked-register.png"
              alt="Email enviada"
              class="img-fluid"
            >
          </div>
          <h3
            class="text-center mb-3 fw-bold mx-3"
            style="color:#394A64"
          >
            ¡Gracias por tu registro!
          </h3>
          <p
            style="color:#56647A"
            class="mx-3 text-center"
          >
            Recibirás en tu correo los datos de los conductores interesados en tu garaje. Esperamos que encuentres pronto tu inquilino. ¡Suerte!
          </p>
        </div>
      </div>
      <div
        v-if="completed"
        style="height: 50px;"
        class="mx-3 mb-3"
      >
        <button
          class="btn py-2 w-100 rounded-3"
          style="background-color: #15E0DD; font-size: 1.1rem;font-weight: 600; color: #011638"
          @click="close"
        >
          <span>Cerrar</span>
        </button>
      </div>
    </div>
    <drawer
      v-if="step==4"
      ref="drawer"
      :input="input"
      :weekdays="weekdays"
      :full_day="full_day"
      :is_parker="true"
      :individual_step="true"
      @get-data-input="handleGetInput"
      style="z-index: 100"
    />
    <drawer-login
      v-if="step==6"
      ref="drawer_login"
      style="z-index: 1000 !important;"
      @login-completed="/*this.trackMixPanel('USUARIO LOGUEADO'),*/save_parker"
      @confirm-mail="this.trackMixPanelLogin('appconfirmpersonaldataparker_click_confirmar', false)"
      @confirm-personal-data="this.trackMixPanelLogin('appconfirmpersonaldataparker_click_confirmar', true)"
    />
    <spinner-component
      id="spinner"
      class="d-none"
      style="z-index: 100;"
    />
  </div>
</template>
<script>
  //import axios from 'axios';
  import SpinnerComponent from '../components/SpinnerComponent.vue'
  import TimeComponent from '../components/TimeComponent.vue'
  import AddressBrowserComponent from '../components/AddressBrowserComponent.vue';
  import { mapState } from 'vuex';
  //import router from '@/router';
  import noPhoto from './../assets/cloud_icon.png';
  import Drawer from '../components/Drawer.vue';
  import DrawerLogin from '../components/DrawerLogin.vue';
  import axios from 'axios';
  import { formatPeriod, formatSize, formatTags } from '../services/traslation';
  import mixpanel from 'mixpanel-browser';

  export default {
    name: 'CreateParker',
    components:{
        SpinnerComponent,
        TimeComponent,
        AddressBrowserComponent,
        Drawer,
        DrawerLogin,
      },
      data: function() {
        return {
          isCollapsed: false,
          step: 0,
          add_tag: "",
          input: {
              address: {},
              time: {
                startTime: "08:00",
                endTime: "18:00"
              },
              weekend_full_day: false,
              vehicle_size: null,
              type:null,
              comments: "",
              tags:["EASY_MANEUVER", "AUTOMATIC_DOOR"],
              electric_car: false,
              monthly_price: null,
              floor: null,
              duration: "indefinite",
              imgs: []
          },
          full_day: false,
          weekdays: true,
          error: null,
          noPhoto,
          hour_error: false,
          default_tags: ["EASY_MANEUVER", "AUTOMATIC_DOOR", "MOBILE_OPENING", "FREIGHT_ELEVATOR", "PEDESTRIAN_ELEVATOR", "HOMYHUB", "SECURITY_CAMERAS", "SECURITY_PERSONNEL"],
          form_error:false,
          completed: false,
          steps_names: [ "", "Ubicación", "Horario", "Tamaño", "Precio", "Información", "Fotos"]
        }
      },
    computed: {
      ...mapState(['isLoggedIn']),
      ...mapState(['token']),
      formattedSize() {
        return formatSize(this.input.vehicle_size);
      },
      formattedPeriod(){
        return formatPeriod(this.input.duration)
      },
      formattedFloor(){
        if(!this.input.floor){
          return ""
        }
        else if(this.input.floor<0){
          return "Sótano " + this.input.floor
        }
        else if(this.input.floor==0){
          return "Planta Baja"
        }
        else{
          return "Planta " + this.input.floor
        }
      },
      formattedStreet() {
      return this.input.address.street.length > 15 ? this.input.address.street.slice(0, 15) + "..." : this.input.address.street;
    },
    },
    watch:{
      weekdays(){
        if(this.weekdays){
          this.input.time.startTime=this.input.time.startTime ?? "08:00"
          this.input.time.endTime=this.input.time.endTime ?? "18:00"
        }else{
          this.input.time.startTime=null
          this.input.time.endTime=null
          this.full_day = false
        }
        this.$nextTick(() => { if (this.$refs.time_component) { console.log(this.input.time); this.$refs.time_component.CambiarHoras(this.input.time); } })
      },
      full_day(){
        if(this.full_day){
          this.input.time.startTime="00:00"
          this.input.time.endTime="00:00"
          //this.$refs.time_component.CambiarHoras(this.input.time)
        }
      },
      step(){
        switch(this.step){
          case 1:
              this.isCollapsed=false;
              break;
          case 2:
              this.isCollapsed=false;
              break;
          case 3:
              this.isCollapsed=false;
              break;
          case 4:
              this.isCollapsed=false;
              break;
        }
      }
    },
    methods:{
      trackMixPanel(mensaje){
        mixpanel.track(mensaje, {
          pantalla: 'Create Parker'
        });
      },
      trackMixPanelLogin(mensaje, isNewUser){
        let userType = isNewUser ? 'newUser' : 'existing';
        mixpanel.track(mensaje, {
          pantalla: 'Create Parker',
          userType: userType
        });
      },
      handleInputPrice(event){
        this.input.monthly_price = event.target.value === "" ? null : Number(event.target.value);
      },
      close() {
        window.open("https://parkiduo.com", "_blank");
        },
      formatTag(tag) {
        return formatTags(tag)
      },
      toggleTag(tag) {
        const index = this.input.tags.indexOf(tag);
        if (index !== -1) {
          this.input.tags.splice(index, 1); // Elimina correctamente el tag seleccionado
        } else {
          this.input.tags.push(tag); // Agrega el tag si no está
        }
      },
      deleteImage(index) {
        if(index == (this.input.imgs.length-1) && index>0){
          document.getElementById('img0').classList.add('active');
        }
        this.input.imgs.splice(index, 1);
      },
      handleGetInput(input){
        this.input.address = input.address
        this.weekdays = input.time.startTime!=null ? true : false
        this.input.time.startTime = input.time.startTime
        this.input.time.endTime = input.time.endTime
        this.full_day = input.time.startTime == "00:00" && input.time.endTime == "00:00" ? true : false
        this.input.weekend_full_day = input.weekend_full_day
        this.input.vehicle_size = input.vehicle_size
      },
      open_drawer(step){
        this.$refs.drawer.openDrawer()
        this.$refs.drawer.change_step(step)
      },
      triggerCamera() {
        this.$refs.cameraInput.click();
      },
      triggerFileInput() {
        // Aseguramos que la referencia existe antes de llamar al método click()
        if (this.$refs.fileInput) {
          this.$refs.fileInput.click();
        }
      },
      handleFileChange(event) {
        const files = event.target.files;
        for (let i = 0; i < files.length; i++) {
          if (files[i]) {
            if (!files[i].type.startsWith('image/')) {
              break; // Salir si no es una imagen
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                this.input.imgs.push(e.target.result);
                console.log(this.input.imgs)
            };
            reader.readAsDataURL(files[i]);
          }
        }
      },
        handleGetAddress(address){
          this.isCollapsed = true;
          this.input.address.address = address.address
          this.input.address.zip_code = address.zip_code || ""
          this.input.address.city = address.city
          this.input.address.street = address.street
          this.input.address.center = address.center
          this.input.address.state = address.state

          this.step = 2
          this.trackMixPanel('applocationparker_click_confirmar ubicación')
          this.$nextTick(() => { if (this.$refs.time_component) { this.$refs.time_component.CambiarHoras(this.input.time); } })
        },
        handleGetDataHoras(time){
          console.log("handleGetDataHoras")
          this.input.time = time
        },
        async save_parker(){
          this.trackMixPanel('appgarageform_click_registrar plaza de garaje')

          if(!this.input.duration || !this.input.monthly_price ){ //|| !this.input.type
            this.form_error = true
            //this.trackMixPanel("DATOS INVALIDOS")
            return
          }

          if(!this.isLoggedIn){
            this.$refs.drawer_login.openDrawer()
            //this.trackMixPanel("ABRIR DRAWER LOGIN")
            return
          }

          var spinner = document.getElementById("spinner")
          spinner.classList.remove("d-none")

          let startMinutes = 0
          let endMinutes = 0
          if(this.weekdays){
            if(this.full_day){
              startMinutes = 0
              endMinutes = 0
            }
            else {
              const [startHour, startMinute] = this.input.time.startTime.split(":").map(Number);
              startMinutes = startHour * 60 + startMinute;

              const [endHour, endMinute] = this.input.time.endTime.split(":").map(Number);
              endMinutes = endHour * 60 + endMinute;
            }
          }
          console.log(this.input.address)

          const body = {
            location: {
              latitude: this.input.address.center[0],
              longitude: this.input.address.center[1]
            },
            address: {
              street: this.input.address.street,
              city: this.input.address.city,
              state: this.input.address.state,
              zip_code: this.input.address.zip_code,
            },
            vehicle_size: this.input.vehicle_size,
            floor: this.input.floor,
            monthly_price: this.input.monthly_price,
            ownership: null,//this.input.type,
            tags: this.input.tags,
            comments: this.input.comments,
            images: this.input.imgs,
            weekend_full_day: this.input.weekend_full_day,
            start_hour: startMinutes,
            end_hour: endMinutes,
            period: this.input.duration,
            electric_car: this.input.electric_car
          }

          await axios.post(process.env.VUE_APP_API_URL + '/api/parking_lots',
            body,{
            headers: {
              'Authorization': `Bearer ${this.token}`
              },}
          )

          this.step++
          this.trackMixPanel('appcompleteparker_registrar plaza de garaje')
          this.completed=true

          spinner.classList.add("d-none")
        }
    }
  }
</script>
<style scoped>

.form-check-input{
    height: 20px !important;
}

.el-select__wrapper{
    padding: 0px;
    margin: 0px;
}



  .tab{
    height: 5px;
    margin-top: 10px;
    width: 13%;
    background-color: #AAB1BD;
    border-radius: 100px;
  }

  #folding_tab{
    background-color: #F5F6F8 !important;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    transition: height 0.5s ease;
    z-index: 100;
    position: absolute;
    width: 100%;
  }

  #folding_tab.collapsed {
        height: 60vh;
        bottom: 0 !important;
    }



    .form-check-input:checked {
        background-color: #15E0DD;
        border-color: #15E0DD;
    }

    .truncated-text {
      white-space: nowrap;        /* Evita saltos de línea */
      overflow: hidden;           /* Oculta el texto que se pase */
      text-overflow: ellipsis;    /* Agrega "..." al final si es muy largo */
      max-width: 100%;            /* Asegura que no crezca más allá del col-6 */
      display: block;             /* Asegura que respete los estilos de ancho */
    }

    .form-control:focus {
      outline: none !important;  /* Elimina el contorno azul de Bootstrap */
      box-shadow: none !important;  /* Quita el resplandor */
      border: none !important;  /* Elimina el borde */
    }

    .etiqueta{
      background-color: #F5F6F8;
      border: 1px solid #E3E5E9;
      margin-right: 10px;
      padding: 4px 10px 4px 10px;
      border-radius: 5px;
      margin-bottom: 10px;
    }

    .selected_tag{
      background-color: #B7F7F5;
      border: 1px solid #011638;
    }

    .input-no-border {
      outline: none;
      border: 1px solid #ccc; /* Puedes personalizar el borde si lo necesitas */
      padding: 5px;
      -moz-appearance: textfield; /* Firefox */
      appearance: textfield; /* Otros navegadores */
    }
    .input-no-border:focus {
      border: 1px solid blue; /* Opcional: cambiar color en focus */
    }

    .input-no-border::-webkit-inner-spin-button,
    .input-no-border::-webkit-outer-spin-button {
      -webkit-appearance: none; /* Chrome, Safari, Edge */
      margin: 0;
    }

    .contenedor-imagenes {
      display: flex;
      flex-wrap: wrap;
      justify-content: center; /* Centra las imágenes horizontalmente */
      gap: 16px;
      width: 100%;
    }

    .imagen-wrapper {
      position: relative;
      width: calc(50% - 16px); /* 2 imágenes por fila, restando el gap */
      aspect-ratio: 4 / 3; /* Puedes ajustar la relación (4/3, 1/1, 16/9, etc.) */
      overflow: hidden;
      border-radius: 8px;
      background-color: #f0f0f0;
    }

    .imagen {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }


    .stepper-wrapper {
        position: relative;
        width: 100%;
        max-width: 500px;
      }

      .stepper {
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 2;
      }

      .step-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        position: relative;
        width: 60px;
      }

      .step {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #ccc;
        border: 2px solid #ccc;
        z-index: 2;
      }

      .step.completed {
        background-color: #011638;
        border-color: #011638;
      }

      .step.active {
        background-color: white;
        border: 3px solid #011638;
      }

      .step-label {
        font-size: 12px;
        color: #555;
      }

      /* Líneas */
      .line {
        position: absolute;
        top: 10px; /* altura media de las bolitas (20px / 2) */
        height: 1px;
        background-color: #ccc;
        z-index: 1;
      }

      .line-1 {
        left: calc(60px / 2);
        right: calc(100% / 3 + 60px / 2);
      }

      .line-2 {
        left: calc(100% / 3 + 60px / 2);
        right: calc(60px / 2);
      }




</style>
